const destinations = {
  main: "/",
  projects: "/projects",
  reachmeout: "/reachmeout",
}

export default destinations
